"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useRestoreFocusTarget: function() {
        return useRestoreFocusTarget;
    },
    useRestoreFocusSource: function() {
        return useRestoreFocusSource;
    }
});
const _tabster = require("tabster");
const _useTabster = require("./useTabster");
function useRestoreFocusTarget() {
    const tabster = (0, _useTabster.useTabster)();
    // Initializes the restorer API
    if (tabster) {
        (0, _tabster.getRestorer)(tabster);
    }
    return (0, _tabster.getTabsterAttribute)({
        restorer: {
            type: _tabster.Types.RestorerTypes.Target
        }
    });
}
function useRestoreFocusSource() {
    const tabster = (0, _useTabster.useTabster)();
    // Initializes the restorer API
    if (tabster) {
        (0, _tabster.getRestorer)(tabster);
    }
    return (0, _tabster.getTabsterAttribute)({
        restorer: {
            type: _tabster.Types.RestorerTypes.Source
        }
    });
}
